import {isEqual} from 'lodash';
import {useEffect, useState} from 'react';

/**
 * Returns a memoized value that only updates when the input value changes.
 *
 * @param {any} value - The value to be memoized.
 * @return {any} The memoized value.
 */
export function useMemoizedValue(value) {
    const [storedValue, setStoredValue] = useState(value);

    useEffect(() => {
        setStoredValue(storedValue => (isEqual(storedValue, value) ? storedValue : value));
    }, [value]);

    return storedValue;
}
